import * as R from "ramda";
import { createHandlers } from "redux-mvc";
import { NAMESPACE, MODES } from "./constants";

// Initial State
const iniState = {
  loading: true,
  mode: MODES.EMAIL,
  moduleId: null,
  records: [],
  activeStepIndex: 0,
  generatingPreviews: false,
  sendingEmails: false,
  selectedOptions: null,
  subject: "",
  message: "",
  messagePlainText: "",
  replyTo: "",
  emailType: "custom",
  attachments: [],
  newTemplate: false,
  templateTitle: "",
  invoiceDueDate: null,
  invoiceNotes: "",
  groupByRecipient: false,
  messagePreviews: [],
  bodyRef: null,
  sourceRecordId: null,
  sourceFormId: null,
  sourceOrderId: null,
  preview: null,
  multiplePreview: [],
  particularContactsSelected: [],
  formattedSelectedIndividualContacts: []
};

const model = createHandlers({
  iniState,
  reducers: {
    init: (_, { payload }) => ({
      loading: false,
      mode: payload.mode,
      records: payload.records,
      moduleId: payload.moduleId,
      selectedOptions: payload.selectedOptions,
      subject: payload.subject,
      message: payload.message,
      replyTo: payload.replyTo,
      emailType: payload.emailType,
      attachments: payload.attachments,
      invoiceDueDate: payload.invoiceDueDate,
      sourceRecordId: payload.sourceRecordId,
      sourceFormId: payload.sourceFormId,
      sourceOrderId: payload.sourceOrderId
    }),
    handleNextStep: R.identity,
    refreshPreviews: R.identity,
    getPreview: R.identity,
    updateMessage: R.identity,
    onOptionSelect: (_, { payload: selected }) => ({
      selectedOptions: selected ? selected.value : selected
    }),
    handleBackStep: state => ({
      activeStepIndex: Math.max(state.activeStepIndex - 1, 0)
    }),
    toggleTemplate: state => ({
      newTemplate: !state.newTemplate
    }),
    toggleGroupByRecipient: state => ({
      groupByRecipient: !state.groupByRecipient
    }),
    handleResponse: (_, { payload: reponseProps }) => ({
      ...reponseProps
    }),
    handleSelectParticularContact: R.identity,
    selectAllHandler: R.identity
  },
  namespace: NAMESPACE
});

const { actions, getters } = model;

export { actions, getters };

export default model;
